module.exports = __webpack_public_path__ + "img/mm-success@3x.6f537695.png";